



















































import {Component, Prop, Vue} from 'vue-property-decorator'
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import CategoryListSorter from "@/components/ListSorter/CategoryListSorter.vue";
import AddCategoryDialog from "@/components/Dialog/AddCategoryDialog.vue";
import EditCategoryDialog from "@/components/Dialog/EditCategoryDialog.vue";
import DeleteCategoryDialog from "@/components/Dialog/DeleteCategoryDialog.vue";
import MenusStore from "@/store/modules/MenusStore";

interface Category {
    name: string
    imgSrc: string
}

@Component({
    components: {
        CategoryListSorter,
        DeleteCategoryDialog,
        EditCategoryDialog,
        AddCategoryDialog,
    },
})
export default class CategoryNavi extends Vue {
    private isAddingCategory = false;
    private editingCategoryId = -1;
    private deletingCategoryId = -1;

    get menuId(): number {
        return Number(this.$route.params.menuId);
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[this.menuId] || {};
    }


    get editingCategory(): CMS.Category {
        return CategoriesStore.categoryById[this.editingCategoryId];
    }

    get deletingCategory(): CMS.Category {
        return CategoriesStore.categoryById[this.deletingCategoryId];
    }

    get enableRegister(): boolean {
        return CategoriesStore.all.length < 8;
    }

    // ソート
    private onChangeSort(sortedIds: number[]): void {
        CategoriesStore.localSort(sortedIds);
    }

    private onEndSort() {
        CategoriesStore.applySort();
    }

    // 追加
    private onClickAddCategory(): void {
        this.isAddingCategory = true;
    }

    private onCancelAddCategory(): void {
        this.isAddingCategory = false;
    }

    private async onOkAddCategory(category: CMS.Category) {
        // カテゴリーを登録
        await CategoriesStore.create(category);
        this.isAddingCategory = false;
        this.$router.replace({name: 'menu_item', params: {categoryId: CategoriesStore.lastCategoryId.toString()}}, () => {})
    }

    // 編集
    private onSelectEdit(categoryId: number): void {
        this.editingCategoryId = categoryId;
    }

    private onCancelEditCategory(): void {
        this.editingCategoryId = -1;
    }

    private onOkEditCategory(category: CMS.Category): void {
        CategoriesStore.edit(category);
        this.editingCategoryId = -1;
    }

    // 削除
    private onSelectDelete(categoryId: number): void {
        this.deletingCategoryId = categoryId;
    }

    private onCancelDeleteCategory(): void {
        this.deletingCategoryId = -1;
    }

    private async onOkDeleteCategory() {
        await CategoriesStore.delete(this.deletingCategoryId);
        this.deletingCategoryId = -1;
        this.$router.replace({name: 'menu_item', params: {categoryId: CategoriesStore.firstCategoryId.toString()}}, () => {})
    }
}
